import { render, staticRenderFns } from "./BuyerPurchase.vue?vue&type=template&id=f601c63e&scoped=true&"
import script from "./BuyerPurchase.vue?vue&type=script&lang=js&"
export * from "./BuyerPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f601c63e",
  null
  
)

export default component.exports